export default {
  path: "/classroomQuery",
  name: "ClassroomQuery",
  redirect: "/classroomQuery/index",
  meta: {
    title: "教室查询",
    showMainMenu: false
    // icon: "icon-query"
  },
  children: [
    {
      path: "/classroomQuery/index",
      name: "classroomQueryIndex",
      component: () =>
        import(/* webpackChunkName: "classroomQuery" */ "@/views/classroomQuery/Index.vue"),
      meta: {
        title: "教室查询",
        showMainMenu: true,
        icon: "icon-query"
      }
    },
    {
      path: "/classroomQuery/ForClassRoom",
      name: "classroomQueryForClassRoom",
      component: () =>
        import(/* webpackChunkName: "classroomQuery" */ "@/views/classroomQuery/ForClassRoom.vue"),
      meta: {
        title: "按教室",
        showMainMenu: false
      }
    },
    {
      path: "/classroomQuery/ForDate",
      name: "classroomQueryForDate",
      component: () =>
        import(/* webpackChunkName: "classroomQuery" */ "@/views/classroomQuery/ForDate.vue"),
      meta: {
        title: "按时间",
        showMainMenu: false
      }
    }
  ]
};
